import angular from "angular";
import template from "./admin-school-create-campus.html";
import AdminSchoolLocationCreateController from "./admin-school-create-campus.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.view.locations.create", {
    url: "/create",
    controller: AdminSchoolLocationCreateController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.create", [])
  .config(config)
  .controller(
    "AdminSchoolLocationCreateController",
    AdminSchoolLocationCreateController,
  );
